import { gql } from '@apollo/client';

// Apollo creates cache id based on the object id, so some nodes may have id which is not being used
export const fetchTransactionAccountForCreateBillingProfile = gql`
  query fetchTransactionAccountForCreateBillingProfile($id: ID!) {
    transactionAccount(id: $id) {
      id
      billingAccountsList {
        status
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          default
          paymentIssue
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
            totalCreditLimit
            paymentMethod
          }
          ... on PayPal {
            payPal {
              name
              email
            }
          }
          ... on Ach {
            ach {
              bankName
              last4
            }
          }
        }
      }
    }
  }
`;
